'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multihashing = require('multihashing-async');

var multicodec = require('multicodec'); // binary resolver


module.exports = {
  codec: multicodec.RAW,
  defaultHashAlg: multicodec.SHA2_256,
  resolver: {
    /**
     * Resolves a path within a Raw block.
     *
     * Always returns the raw data as value without any remainderPath.
     *
     * @param {Buffer} binaryBlob - Binary representation of a PB block
     * @param {string} [path='/'] - Path that should be resolved.  Must be '/' or an exception is thrown
     * @returns {Object} result - Result of the path it it was resolved successfully
     * @returns {*} result.value - The raw data
     * @returns {string} result.remainderPath - An empty string
     */
    resolve: function resolve(binaryBlob, path) {
      if (path !== '/') {
        throw new Error('Only the root path / may be resolved');
      }

      return {
        value: binaryBlob,
        remainderPath: ''
      };
    },

    /**
     * Return all available paths of a block.
     *
     * @generator
     * @param {Buffer} binaryBlob - The raw data
     * @returns {Object} - Finished generator with `done: true`
     */
    tree: function tree(binaryBlob) {
      return {
        done: true
      };
    }
  },
  util: {
    deserialize: function deserialize(data) {
      return data;
    },
    serialize: function serialize(data) {
      return data;
    },

    /**
     * Calculate the CID of the binary blob.
     *
     * @param {Object} binaryBlob - Encoded IPLD Node
     * @param {Object} [userOptions] - Options to create the CID
     * @param {number} [userOptions.cidVersion=1] - CID version number
     * @param {string} [UserOptions.hashAlg] - Defaults to the defaultHashAlg of the format
     * @returns {Promise.<CID>}
     */
    cid: function () {
      var _cid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binaryBlob, userOptions) {
        var defaultOptions, options, multihash, codecName, cid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defaultOptions = {
                  cidVersion: 1,
                  hashAlg: module.exports.defaultHashAlg
                };
                options = Object.assign(defaultOptions, userOptions);
                _context.next = 4;
                return multihashing(binaryBlob, options.hashAlg);

              case 4:
                multihash = _context.sent;
                codecName = multicodec.print[module.exports.codec];
                cid = new CID(options.cidVersion, codecName, multihash);
                return _context.abrupt("return", cid);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function cid(_x, _x2) {
        return _cid.apply(this, arguments);
      }

      return cid;
    }()
  }
};